<template>
  <ion-header class="ion-padding">
    <ion-toolbar color="secondary">
      <div slot="start">
        <h3 class="ion-margin">
          GroSens 2 Admin
        </h3>

        <template
          v-if="isLoggedIn"
        >
          <router-link
            class="ion-margin"
            :to="{ name: 'bridges' }"
            color="light"
          >
            <ion-text color="light">
              Bridges
            </ion-text>
          </router-link>

          <router-link
            v-if="isAdmin"
            class="ion-margin"
            :to="{ name: 'bridge-inventory' }"
            color="light"
          >
            <ion-text color="light">
              Bridge Inventory
            </ion-text>
          </router-link>

          <router-link
            v-if="isAdmin"
            class="ion-margin"
            :to="{ name: 'commits' }"
            color="light"
          >
            <ion-text color="light">
              Commits
            </ion-text>
          </router-link>

          <router-link
            v-if="isAdmin"
            class="ion-margin"
            :to="{ name: 'releases' }"
            color="light"
          >
            <ion-text color="light">
              Releases
            </ion-text>
          </router-link>

          <a
            class="ion-margin"
            :href="analyticsUrl"
            target="_blank"
          >
            Analytics
          </a>

          <a
            class="ion-margin"
            :href="documentationUrl"
            target="_blank"
          >
            Documentation
          </a>
        </template>
      </div>

      <div
        v-if="isLoggedIn"
        slot="end"
      >
        <ion-chip class="ion-margin-vertical">
          <ion-icon
            :src="i.person"
            color="primary"
          />
          <ion-label>{{ user.name }}</ion-label>
          <template v-if="userRole">
            <ion-icon
              :src="i.caretForward"
              color="primary"
            />
            <ion-label color="light">
              {{ userRole }}
            </ion-label>
          </template>
        </ion-chip>
        <ion-button
          class="ion-margin"
          @click="logout"
        >
          <ion-icon
            :src="i.logOut"
          />
        </ion-button>
      </div>
    </ion-toolbar>
  </ion-header>
</template>

<script>
import { mapGetters } from 'vuex'
import userTypes from '@/userTypes'

export default {
  data() {
    return {
      analyticsUrl: process.env.VUE_APP_ANALYTICS_URL,
      documentationUrl: process.env.VUE_APP_DOCUMENTATION_URL
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'isAdmin',
      'isLoggedIn'
    ]),
    userRole(){
      if(!this.user) return null
      if(this.user.type === userTypes.ADMIN ){
        return 'Admin'
      }
      if(this.user.type === userTypes.SUPER_ADMIN ){
        return 'Super admin'
      }
      return null
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
        .then(() => this.$router.push({ name: 'login' }))
    }
  }
}
</script>

<style scoped>
ion-header {
  background: var(--ion-color-secondary);
}

ion-header a {
  color: var(--ion-color-light);
  text-decoration: none;
}

ion-header h3 {
  display:inline;
}

.router-link-active ion-text {
  color: var(--ion-color-light-shade);
}
</style>
